import { EmailBlockData } from '../components/emailBuilder/ModernEmailBuilder';

export interface SavedBlock {
  id: string;
  name: string;
  block: EmailBlockData;
  createdAt: number;
  updatedAt: number;
}

const STORAGE_KEY = 'scubamail_saved_blocks';

export const savedBlocksService = {
  // Get all saved blocks
  getAll(): SavedBlock[] {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) return [];
      return JSON.parse(stored);
    } catch (error) {
      console.error('Error loading saved blocks:', error);
      return [];
    }
  },

  // Save a new block
  save(block: EmailBlockData, name: string): SavedBlock {
    const savedBlock: SavedBlock = {
      id: `saved-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
      name: name.trim(),
      block: JSON.parse(JSON.stringify(block)), // Deep clone
      createdAt: Date.now(),
      updatedAt: Date.now(),
    };

    const allBlocks = this.getAll();
    allBlocks.push(savedBlock);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allBlocks));
    return savedBlock;
  },

  // Delete a saved block
  delete(id: string): void {
    const allBlocks = this.getAll();
    const filtered = allBlocks.filter(b => b.id !== id);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
  },

  // Update a saved block
  update(id: string, updates: Partial<SavedBlock>): SavedBlock | null {
    const allBlocks = this.getAll();
    const index = allBlocks.findIndex(b => b.id === id);
    if (index === -1) return null;

    allBlocks[index] = {
      ...allBlocks[index],
      ...updates,
      updatedAt: Date.now(),
    };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(allBlocks));
    return allBlocks[index];
  },
};

